export var From;
(function (From) {
    let Type;
    (function (Type) {
        Type["View"] = "VIEW";
        Type["Query"] = "QUERY";
        Type["Table"] = "TABLE";
    })(Type = From.Type || (From.Type = {}));
    function query(source, alias) {
        return { source, alias, type: "QUERY" };
    }
    From.query = query;
    function table(name, alias) {
        return { name, alias: alias || name, type: "TABLE" };
    }
    From.table = table;
    function view(name, alias) {
        return { name, alias: alias || name, type: "VIEW" };
    }
    From.view = view;
})(From || (From = {}));
